// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const businessid: CountryValidator<"AT"> = createValidator(
  "at.businessid",
  8,
);

export default businessid;
export const compact = businessid.compact;
export const format = businessid.format;
export const validate = businessid.validate;
export const generate = (): string =>
  businessid.generate?.() ??
  (() => {
    throw new Error(
      "Validator at.businessid cannot generate values",
    );
  })();
